import React from 'react';

import PropTypes from 'prop-types';

export const SalesChannels = (props) => {
    const { salesChannels } = props;

    if (!salesChannels || salesChannels.length === 0) {
        return 'No Sales Channel Selected';
    }

    return (
        <span>
            { salesChannels.map((agent) => agent.name).join(', ') }
        </span>
    );
};

SalesChannels.propTypes = {
    salesChannels: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
    })).isRequired,
};

